export default {
    computed: {
        family () {
            return this.$store.getters['family/getFamily'];
        },
        isFamilyChecked () {
            return (
                (this.family && this.family.is_checked === true) ||
        (this.family && this.family.is_connected === true)
            );
        }
    }
};
